import { render } from "./_TabButton.vue?vue&type=template&id=3352d996&scoped=true"
import script from "./_TabButton.vue?vue&type=script&lang=js"
export * from "./_TabButton.vue?vue&type=script&lang=js"

import "./_TabButton.vue?vue&type=style&index=0&id=3352d996&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3352d996"]])

export default __exports__